import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { QuoteProvider } from "@/components/QuoteDialog";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Training from "@/pages/Training";
import Insights from "@/pages/Insights";
import ArticleDetail from "@/pages/ArticleDetail";
import Gallery from "@/pages/Gallery";
import Team from "@/pages/Team";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App bg-brand-navy">
      <BrowserRouter>
        <QuoteProvider>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/training" element={<Training />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<ArticleDetail />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/team" element={<Team />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" richColors />
        </QuoteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
